<div class="dialog-wrapper" dir="rtl">
  <!-- ── Header ─────────────────────────────────────── -->
  <div class="dialog-header">
    <h2 class="dialog-title">إضافة إشتراك</h2>
    <button class="close-btn" (click)="onClose()">&#x2715;</button>
  </div>

  <!-- ── Body ───────────────────────────────────────── -->
  <div class="dialog-body">
    <!-- نوع الخطة -->
    <div class="form-group">
      <label class="form-label">نوع الخطة</label>
      <div class="select-wrapper">
        <select class="form-select" [(ngModel)]="form.planType" name="planType">
          <option value="إشتراكات رياضية">إشتراكات رياضية</option>
          <option value="خطة عادية">خطة عادية</option>
          <option value="خطة VIP">خطة VIP</option>
        </select>
        <span class="select-arrow">&#8249;</span>
      </div>
    </div>

    <!-- الخطة -->
    <div class="form-group">
      <label class="form-label">الخطة</label>
      <div class="select-wrapper">
        <select class="form-select" [(ngModel)]="form.plan" name="plan">
          <option value="None">None</option>
          <option value="Plan1">Plan 1</option>
          <option value="Plan2">Plan 2</option>
        </select>
        <span class="select-arrow">&#8249;</span>
      </div>
    </div>

    <!-- مدرب التدريبات الخاصة -->
    <div class="form-group">
      <label class="form-label">مدرب التدريبات الخاصة</label>
      <div class="select-wrapper">
        <select class="form-select" [(ngModel)]="form.trainer" name="trainer">
          <option value="None">None</option>
          <option value="Trainer1">Trainer 1</option>
        </select>
        <span class="select-arrow">&#8249;</span>
      </div>
    </div>

    <!-- تاريخ التفعيل -->
    <div class="form-group">
      <label class="form-label">تاريخ التفعيل</label>
      <input
        type="date"
        class="form-input ltr-input"
        [(ngModel)]="form.activationDate"
        name="activationDate"
      />
    </div>

    <!-- السعر -->
    <div class="form-group">
      <label class="form-label">السعر</label>
      <input
        type="number"
        class="form-input ltr-input"
        [(ngModel)]="form.price"
        name="price"
        placeholder="0"
      />
    </div>

    <!-- نسبة الخصم المئوية -->
    <div class="form-group">
      <label class="form-label">نسبة الخصم المئوية</label>
      <input
        type="number"
        class="form-input ltr-input"
        [(ngModel)]="form.discountPercent"
        name="discountPercent"
        placeholder="0"
      />
    </div>

    <!-- الخصم الموسمي -->
    <div class="form-group">
      <label class="form-label">الخصم الموسمي</label>
      <div class="select-wrapper">
        <select
          class="form-select"
          [(ngModel)]="form.seasonalDiscount"
          name="seasonalDiscount"
        >
          <option value="None">None</option>
          <option value="Discount1">Discount 1</option>
        </select>
        <span class="select-arrow">&#8249;</span>
      </div>
    </div>

    <!-- المطلوب بعد الخصم -->
    <div class="form-group">
      <label class="form-label">المطلوب بعد الخصم</label>
      <input
        type="number"
        class="form-input ltr-input bg-light"
        [(ngModel)]="form.totalAfterDiscount"
        name="totalAfterDiscount"
        placeholder="0"
        readonly
      />
    </div>

    <!-- المدفوع نقداً -->
    <div class="form-group">
      <label class="form-label">المدفوع نقداً</label>
      <input
        type="number"
        class="form-input ltr-input"
        [(ngModel)]="form.paidCash"
        name="paidCash"
        placeholder="0"
      />
    </div>

    <!-- المدفوع نقداً (second) -->
    <div class="form-group">
      <label class="form-label">المدفوع نقداً</label>
      <input
        type="number"
        class="form-input ltr-input"
        [(ngModel)]="form.paidCash2"
        name="paidCash2"
        placeholder="0"
      />
    </div>

    <!-- المدفوع بالبطاقة -->
    <div class="form-group">
      <label class="form-label">المدفوع بالبطاقة</label>
      <input
        type="number"
        class="form-input ltr-input"
        [(ngModel)]="form.paidCard"
        name="paidCard"
        placeholder="0"
      />
    </div>

    <!-- المدفوع تحويل فوري -->
    <div class="form-group">
      <label class="form-label">المدفوع تحويل فوري</label>
      <input
        type="number"
        class="form-input ltr-input"
        [(ngModel)]="form.paidTransfer"
        name="paidTransfer"
        placeholder="0"
      />
    </div>

    <!-- تصفير رقم الإيصال الخاص بالإشتراك -->
    <div class="form-group">
      <label class="form-label">تصفير رقم الإيصال الخاص بالإشتراك</label>
      <div class="select-wrapper">
        <select
          class="form-select"
          [(ngModel)]="form.resetReceiptNo"
          name="resetReceiptNo"
        >
          <option value="NO">NO</option>
          <option value="YES">YES</option>
        </select>
        <span class="select-arrow">&#8249;</span>
      </div>
    </div>

    <!-- ── Sessions Grid (3 cols) ─────────────────── -->
    <div class="sessions-grid">
      <div class="session-item">
        <label class="session-label">Massage</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.massage"
          name="massage"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">Inbody</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.inbody"
          name="inbody"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">Meditation</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.meditation"
          name="meditation"
          placeholder="0"
        />
      </div>

      <div class="session-item">
        <label class="session-label">Cupping</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.cupping"
          name="cupping"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">Invitation</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.invitation"
          name="invitation"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">PTSessions</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.ptSessions"
          name="ptSessions"
          placeholder="0"
        />
      </div>

      <div class="session-item">
        <label class="session-label">Fitness</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.fitness"
          name="fitness"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">Nutration</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.nutration"
          name="nutration"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">FreeDays</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.freeDays"
          name="freeDays"
          placeholder="0"
        />
      </div>

      <div class="session-item">
        <label class="session-label">Training</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.training"
          name="training"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">Cash Back</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.cashBack"
          name="cashBack"
          placeholder="0"
        />
      </div>
      <div class="session-item">
        <label class="session-label">Freezes</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.freezes"
          name="freezes"
          placeholder="0"
        />
      </div>

      <!-- KidsArea — single col -->
      <div class="session-item kids-area">
        <label class="session-label">KidsArea</label>
        <input
          type="number"
          class="form-input ltr-input"
          [(ngModel)]="form.kidsArea"
          name="kidsArea"
          placeholder="0"
        />
      </div>
    </div>

    <!-- ── Access Times per Day ───────────────────── -->
    <div class="days-section">
      <ng-container *ngFor="let day of accessDays">
        <div class="day-row">
          <div class="time-group">
            <label class="form-label">وقت الدخول {{ day.label }} إلى</label>
            <input
              type="time"
              class="form-input ltr-input"
              [(ngModel)]="day.timeTo"
              [name]="'timeTo_' + day.key"
            />
          </div>
          <div class="time-group">
            <label class="form-label">وقت الدخول {{ day.label }} من</label>
            <input
              type="time"
              class="form-input ltr-input"
              [(ngModel)]="day.timeFrom"
              [name]="'timeFrom_' + day.key"
            />
          </div>
        </div>
      </ng-container>
    </div>

    <!-- تعليق -->
    <div class="form-group">
      <label class="form-label">تعليق</label>
      <textarea
        class="form-textarea"
        [(ngModel)]="form.comment"
        name="comment"
        rows="3"
      ></textarea>
    </div>

    <!-- تاريخ الإستحقاق -->
    <div class="form-group">
      <label class="form-label">تاريخ الإستحقاق</label>
      <input
        type="date"
        class="form-input ltr-input"
        [(ngModel)]="form.dueDate"
        name="dueDate"
      />
    </div>

    <!-- ملاحظة الفسط -->
    <div class="form-group">
      <label class="form-label">ملاحظة الفسط</label>
      <textarea
        class="form-textarea"
        [(ngModel)]="form.installmentNote"
        name="installmentNote"
        rows="3"
      ></textarea>
    </div>

    <!-- تاريخ التنبية -->
    <div class="form-group">
      <label class="form-label">تاريخ التنبية</label>
      <input
        type="date"
        class="form-input ltr-input"
        [(ngModel)]="form.alertDate"
        name="alertDate"
      />
    </div>

    <!-- رسالة التنبية -->
    <div class="form-group">
      <label class="form-label">رسالة التنبية</label>
      <textarea
        class="form-textarea"
        [(ngModel)]="form.alertMessage"
        name="alertMessage"
        rows="3"
      ></textarea>
    </div>
  </div>

  <!-- ── Footer ─────────────────────────────────────── -->
  <div class="dialog-footer">
    <button class="btn btn-cancel" (click)="onClose()">إلغاء</button>
    <button class="btn btn-submit" (click)="onSubmit()">اتم</button>
  </div>
</div>
